<template>
  <CRow>
    <CCol lg="12">
      <CCard>
        <CCardHeader>
          <strong>Quản lý thông tin khách hàng</strong>
          <div class="card-header-actions">
            <CButton type="button" shape="pill" color="info" @click="createNew">
              <CIcon name="cil-plus"/>
              Thêm mới</CButton>
          </div>
        </CCardHeader>
        <CCardBody class="pt-0">
          <CDataTable
            :items="customers"
            :fields="fields"
            :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
            :itemsPerPageSelect="{label:' ', values: ['10', '100', '200']}"
            :itemsPerPage="100"
            hover
            sorter
            clickable-rows
            pagination
            @row-clicked="editRecord"
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>
            <template #stt="{item, index}">
              <td class="py-2">
                {{index+1}}
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      // Define the table fields
      fields: [
        { key: 'stt', label: 'Stt', _style:'width:3rem;' },
        { key: 'customer', label: 'Khách hàng', _classes: 'font-weight-bold' },
        { key: 'company', label: 'Công ty' },
        { key: 'address', label: 'Địa chỉ' },
        { key: 'receiver', label: 'Người giao nhận' },
        { key: 'role', label: 'Chức vụ' },
        { key: 'phone', label: 'Điện thoại' },
      ],
      // Example data
      customers: [],
    };
  },
  created() {
    this.getAll()
  },
  methods: {
    getAll() {
      this.$request('/api/device/customer').then(res => {
        // console.log(res.data)
        this.customers = res.data.customers
      })
    },
    editRecord(item, index) {
      // console.log('Edit record:', item);
      this.$router.push({
        path: `/device/cusedit`,
        query: {
          id: item.id,
        },
      })
    },
    createNew() {
      this.$router.push({
        path: '/device/cusedit',
      })
    }
  }
};
</script>
